import { useCallback } from 'react';

import { useUpdatePintoWriterCampaignMutation } from '../core/graphql/operation-hooks';
import { UpdatePintoProductCampaignInput } from '../core/graphql/types';

const useMutationUpdatePintoWriterCampaign = () => {
  const [mutateUpdatePintoWriterCampaign, { loading: isLoadingMutateUpdatePintoWriterCampaign }] = useUpdatePintoWriterCampaignMutation();

  const onMutateUpdatePintoWriterCampaign = useCallback(
    (productCampaignId: string, input: UpdatePintoProductCampaignInput) => {
      const variables = { productCampaignId, input };
      return mutateUpdatePintoWriterCampaign({ variables });
    },
    [mutateUpdatePintoWriterCampaign],
  );

  return {
    onMutateUpdatePintoWriterCampaign,
    isLoadingMutateUpdatePintoWriterCampaign,
  };
};

export default useMutationUpdatePintoWriterCampaign;
